<template>
  <div class="m-0 dbozone-font" :class="`${lang}-font`">
    <div class="container d-flex flex-column justify-content-center">
      <div class="d-flex flex-column nav-name">
        <section class="d-flex p-2">
          <h5 class="font-weight-bold m-0 text-title" :class="`-${lang} -solar`">{{ $t('solar.paytable.symtable_title') }}</h5>
        </section>
      </div>
      <div class="col-12 justify-content-center d-flex flex-row">
        <div class="col-3 p-0">
          <img class="mt-3 icon-paytable" :src="require(`../../assets/paytable/solarSpace/Wild.png`)"
          alt="">
        </div>
        <div class="col-3 p-0 d-flex align-items-center">
          <span class="font-weight-bold text-sub mt-4" :class="`-${lang}`">
            {{$t('solar.paytable.symtable_wild1')}}
            <br>{{$t('solar.paytable.symtable_wild2')}}
          </span>
        </div>
        <div class="col-3 p-0">
          <img class="mt-3 icon-paytable" :src="require(`../../assets/paytable/solarSpace/Scatter.png`)"
          alt="">
        </div>
        <div class="col-3 align-items-center p-0 d-flex">
          <span class="font-weight-bold text-sub mt-4" :class="`-${lang}`">{{$t('solar.paytable.symtable_wild1')}}
            <br>{{$t('solar.paytable.symtable_scatter')}}
          </span>
        </div>
      </div>
      <div class="col-12 justify-content-center d-flex flex-row mt-5">
        <div class="col-3 p-0">
          <img class="mt-3 icon-paytable" :src="require(`../../assets/paytable/solarSpace/H4.png`)"
          alt="">
        </div>
        <div class="col-3 p-0 d-flex mt-2 align-items-center">
          <span class=" text-sub" :class="`-${lang}`">{{'5 - ' + paytable[2][3]}}
            <br>{{'4 - ' + paytable[2][2]}}
            <br>{{'3 - ' + paytable[2][1]}}
          </span>
        </div>
        <div class="col-3 p-0 align-items-center d-flex">
          <img class="mt-3 icon-paytable" :src="require(`../../assets/paytable/solarSpace/H3.png`)"
          alt="">
        </div>
        <div class="col-3 p-0 d-flex mt-2 align-items-center">
          <span class=" text-sub" :class="`-${lang}`">{{'5 - ' + paytable[3][3]}}
            <br>{{'4 - ' + paytable[3][2]}}
            <br>{{'3 - ' + paytable[3][1]}}
          </span>
        </div>
      </div>
      <div class="col-12 mt-1 justify-content-center d-flex flex-row mt-5">
        <div class="col-3 p-0">
          <img class="mt-3 icon-paytable" :src="require(`../../assets/paytable/solarSpace/H2.png`)"
          alt="">
        </div>
        <div class="col-3 p-0 d-flex mt-2 align-items-center">
          <span class=" text-sub" :class="`-${lang}`">{{'5 - ' + paytable[4][3]}}
            <br>{{'4 - ' + paytable[4][2]}}
            <br>{{'3 - ' + paytable[4][1]}}
          </span>
        </div>
        <div class="col-3 p-0 align-items-center d-flex">
          <img class="mt-3 icon-paytable" :src="require(`../../assets/paytable/solarSpace/H1.png`)"
          alt="">
        </div>
        <div class="col-3 p-0 d-flex mt-2 align-items-center">
          <span class=" text-sub" :class="`-${lang}`">{{'5 - ' + paytable[5][3]}}
            <br>{{'4 - ' + paytable[5][2]}}
            <br>{{'3 - ' + paytable[5][1]}}
          </span>
        </div>
      </div>
      <div class="col-12 justify-content-center d-flex flex-row mt-5">
        <div class="col-3 p-0">
          <img class="mt-3 icon-paytable" :src="require(`../../assets/paytable/solarSpace/L4.png`)"
          alt="">
        </div>
        <div class="col-3 p-0 d-flex mt-2 align-items-center">
          <span class=" text-sub" :class="`-${lang}`">{{'5 - ' + paytable[6][3]}}
            <br>{{'4 - ' + paytable[6][2]}}
            <br>{{'3 - ' + paytable[6][1]}}
          </span>
        </div>
        <div class="col-3 p-0">
          <img class="mt-3 icon-paytable" :src="require(`../../assets/paytable/solarSpace/L3.png`)"
          alt="">
        </div>
        <div class="col-3 p-0 d-flex mt-2 align-items-center">
          <span class=" text-sub" :class="`-${lang}`">{{'5 - ' + paytable[7][3]}}
            <br>{{'4 - ' + paytable[7][2]}}
            <br>{{'3 - ' + paytable[7][1]}}
          </span>
        </div>
      </div>
      <div class="col-12 mt-3 justify-content-center d-flex flex-row mt-5">
        <div class="col-3 p-0">
          <img class="mt-3 icon-paytable" :src="require(`../../assets/paytable/solarSpace/L2.png`)"
          alt="">
        </div>
        <div class="col-3 p-0 d-flex mt-2 align-items-center">
          <span class=" text-sub" :class="`-${lang}`">{{'5 - ' + paytable[8][3]}}
            <br>{{'4 - ' + paytable[8][2]}}
            <br>{{'3 - ' + paytable[8][1]}}
          </span>
        </div>
        <div class="col-3 p-0 d-flex align-items-center">
          <img class="mt-3 icon-paytable" :src="require(`../../assets/paytable/solarSpace/L1.png`)"
          alt="">
        </div>
        <div class="col-3 p-0 d-flex mt-2 align-items-center">
          <span class=" text-sub" :class="`-${lang}`">{{'5 - ' + paytable[9][3]}}
            <br>{{'4 - ' + paytable[9][2]}}
            <br>{{'3 - ' + paytable[9][1]}}
          </span>
        </div>
      </div>
      <div class="d-flex flex-column nav-name mt-5">
        <section class="d-flex p-2">
          <h5 class="font-weight-bold m-0 text-title" :class="`-${lang} -solar`">{{ $t('solar.paytable.freeSpinsAlien') }}</h5>
        </section>
      </div>
      <div class="col-12 justify-content-center d-flex flex-row mt-5">
        <div class="col-3 p-0">
          <img class="mt-3 icon-paytable" :src="require(`../../assets/paytable/solarSpace/H4.png`)"
          alt="">
        </div>
        <div class="col-3 p-0 d-flex mt-2 align-items-center">
          <span class=" text-sub" :class="`-${lang}`">{{'5 - ' + paytable[2][3]}}
            <br>{{'4 - ' + paytable[2][2]}}
            <br>{{'3 - ' + paytable[2][1]}}
          </span>
        </div>
        <div class="col-3 p-0">
          <img class="mt-3 icon-paytable" :src="require(`../../assets/paytable/solarSpace/Freespin_h3.png`)"
          alt="">
        </div>
        <div class="col-3 p-0 d-flex mt-2 align-items-center">
          <span class=" text-sub" :class="`-${lang}`">{{'5 - ' + paytable[3][3]}}
            <br>{{'4 - ' + paytable[3][2]}}
            <br>{{'3 - ' + paytable[3][1]}}
          </span>
        </div>
      </div>
      <div class="col-12 justify-content-center d-flex flex-row mt-5">
        <div class="col-3 p-0">
          <img class="mt-3 icon-paytable" :src="require(`../../assets/paytable/solarSpace/H2.png`)"
          alt="">
        </div>
        <div class="col-3 p-0 d-flex mt-2 align-items-center">
          <span class=" text-sub" :class="`-${lang}`">{{'5 - ' + paytable[4][3]}}
            <br>{{'4 - ' + paytable[4][2]}}
            <br>{{'3 - ' + paytable[4][1]}}
          </span>
        </div>
        <div class="col-3 p-0 align-items-center d-flex">
          <img class="mt-3 icon-paytable" :src="require(`../../assets/paytable/solarSpace/Freespin_h1.png`)"
          alt="">
        </div>
        <div class="col-3 p-0 d-flex mt-2 align-items-center">
          <span class=" text-sub" :class="`-${lang}`">{{'5 - ' + paytable[5][3]}}
            <br>{{'4 - ' + paytable[5][2]}}
            <br>{{'3 - ' + paytable[5][1]}}
          </span>
        </div>
      </div>
      <div class="col-12 justify-content-center d-flex flex-row mt-5">
        <div class="col-3 p-0">
          <img class="mt-3 icon-paytable" :src="require(`../../assets/paytable/solarSpace/L4.png`)"
          alt="">
        </div>
        <div class="col-3 p-0 d-flex mt-2 align-items-center">
          <span class=" text-sub" :class="`-${lang}`">{{'5 - ' + paytable[6][3]}}
            <br>{{'4 - ' + paytable[6][2]}}
            <br>{{'3 - ' + paytable[6][1]}}
          </span>
        </div>
        <div class="col-3 p-0">
          <img class="mt-3 icon-paytable" :src="require(`../../assets/paytable/solarSpace/Freespin_l3.png`)"
          alt="">
        </div>
        <div class="col-3 p-0 d-flex mt-2 align-items-center">
          <span class=" text-sub" :class="`-${lang}`">{{'5 - ' + paytable[7][3]}}
            <br>{{'4 - ' + paytable[7][2]}}
            <br>{{'3 - ' + paytable[7][1]}}
          </span>
        </div>
      </div>
      <div class="col-12 mt-3 justify-content-center d-flex flex-row mt-5">
        <div class="col-3 p-0">
          <img class="mt-3 icon-paytable" :src="require(`../../assets/paytable/solarSpace/L2.png`)"
          alt="">
        </div>
        <div class="col-3 p-0 d-flex mt-2 align-items-center">
          <span class=" text-sub" :class="`-${lang}`">{{'5 - ' + paytable[8][3]}}
            <br>{{'4 - ' + paytable[8][2]}}
            <br>{{'3 - ' + paytable[8][1]}}
          </span>
        </div>
        <div class="col-3 p-0 d-flex align-items-center">
          <img class="mt-3 icon-paytable" :src="require(`../../assets/paytable/solarSpace/Freespin_l1.png`)"
          alt="">
        </div>
        <div class="col-3 p-0 d-flex mt-2 align-items-center">
          <span class=" text-sub" :class="`-${lang}`">{{'5 - ' + paytable[9][3]}}
            <br>{{'4 - ' + paytable[9][2]}}
            <br>{{'3 - ' + paytable[9][1]}}
          </span>
        </div>
      </div>
      <div class="d-flex flex-column nav-name mt-5">
        <section class="d-flex p-2">
          <h5 class="font-weight-bold m-0 text-title" :class="`-${lang} -solar`">{{ $t('solar.paytable.freeSpinsHuman') }}</h5>
        </section>
      </div>
      <div class="col-12 justify-content-center d-flex flex-row mt-5">
        <div class="col-3 p-0">
          <img class="mt-3 icon-paytable" :src="require(`../../assets/paytable/solarSpace/Freespin_h4.png`)"
          alt="">
        </div>
        <div class="col-3 p-0 d-flex mt-2 align-items-center">
          <span class=" text-sub" :class="`-${lang}`">{{'5 - ' + paytable[2][3]}}
            <br>{{'4 - ' + paytable[2][2]}}
            <br>{{'3 - ' + paytable[2][1]}}
          </span>
        </div>
        <div class="col-3 p-0">
          <img class="mt-3 icon-paytable" :src="require(`../../assets/paytable/solarSpace/H3.png`)"
          alt="">
        </div>
        <div class="col-3 p-0 d-flex mt-2 align-items-center">
          <span class=" text-sub" :class="`-${lang}`">{{'5 - ' + paytable[3][3]}}
            <br>{{'4 - ' + paytable[3][2]}}
            <br>{{'3 - ' + paytable[3][1]}}
          </span>
        </div>
      </div>
      <div class="col-12 justify-content-center d-flex flex-row mt-5">
        <div class="col-3 p-0">
          <img class="mt-3 icon-paytable" :src="require(`../../assets/paytable/solarSpace/Freespin_h2.png`)"
          alt="">
        </div>
        <div class="col-3 p-0 d-flex mt-2 align-items-center">
          <span class=" text-sub" :class="`-${lang}`">{{'5 - ' + paytable[4][3]}}
            <br>{{'4 - ' + paytable[4][2]}}
            <br>{{'3 - ' + paytable[4][1]}}
          </span>
        </div>
        <div class="col-3 p-0 align-items-center d-flex">
          <img class="mt-3 icon-paytable" :src="require(`../../assets/paytable/solarSpace/H1.png`)"
          alt="">
        </div>
        <div class="col-3 p-0 d-flex mt-2 align-items-center">
          <span class=" text-sub" :class="`-${lang}`">{{'5 - ' + paytable[5][3]}}
            <br>{{'4 - ' + paytable[5][2]}}
            <br>{{'3 - ' + paytable[5][1]}}
          </span>
        </div>
      </div>
      <div class="col-12 justify-content-center d-flex flex-row mt-5">
        <div class="col-3 p-0">
          <img class="mt-3 icon-paytable" :src="require(`../../assets/paytable/solarSpace/Freespin_l4.png`)"
          alt="">
        </div>
        <div class="col-3 p-0 d-flex mt-2 align-items-center">
          <span class=" text-sub" :class="`-${lang}`">{{'5 - ' + paytable[6][3]}}
            <br>{{'4 - ' + paytable[6][2]}}
            <br>{{'3 - ' + paytable[6][1]}}
          </span>
        </div>
        <div class="col-3 p-0">
          <img class="mt-3 icon-paytable" :src="require(`../../assets/paytable/solarSpace/L3.png`)"
          alt="">
        </div>
        <div class="col-3 p-0 d-flex mt-2 align-items-center">
          <span class=" text-sub" :class="`-${lang}`">{{'5 - ' + paytable[7][3]}}
            <br>{{'4 - ' + paytable[7][2]}}
            <br>{{'3 - ' + paytable[7][1]}}
          </span>
        </div>
      </div>
      <div class="col-12 mt-3 justify-content-center d-flex flex-row mt-5">
        <div class="col-3 p-0">
          <img class="mt-3 icon-paytable" :src="require(`../../assets/paytable/solarSpace/Freespin_l2.png`)"
          alt="">
        </div>
        <div class="col-3 p-0 d-flex mt-2 align-items-center">
          <span class=" text-sub" :class="`-${lang}`">{{'5 - ' + paytable[8][3]}}
            <br>{{'4 - ' + paytable[8][2]}}
            <br>{{'3 - ' + paytable[8][1]}}
          </span>
        </div>
        <div class="col-3 p-0 d-flex align-items-center">
          <img class="mt-3 icon-paytable" :src="require(`../../assets/paytable/solarSpace/L1.png`)"
          alt="">
        </div>
        <div class="col-3 p-0 d-flex mt-2 align-items-center">
          <span class=" text-sub" :class="`-${lang}`">{{'5 - ' + paytable[9][3]}}
            <br>{{'4 - ' + paytable[9][2]}}
            <br>{{'3 - ' + paytable[9][1]}}
          </span>
        </div>
      </div>
      <div class="d-flex flex-column nav-name mt-4">
        <section class="d-flex p-2">
          <h5 class="font-weight-bold m-0 text-title" :class="`-${lang} -solar`">{{ $t('solar.freespin') }}</h5>
        </section>
      </div>
      <div class="d-flex p-2 mt-1">
        <span class=" m-0 text-sub" :class="`-${lang}`">{{ $t('solar.text-freespin1') }}</span>
      </div>
      <div class="d-flex p-2 mt-1">
        <span class=" m-0 text-sub" :class="`-${lang}`">{{ $t('solar.text-freespin2') }}</span>
      </div>
      <div class="d-flex p-2 mt-1">
        <span class=" m-0 text-sub" :class="`-${lang}`">{{ $t('solar.text-freespin3') }}</span>
      </div>
      <div class="d-flex p-2 mt-1">
        <span class=" m-0 text-sub" :class="`-${lang}`">{{ $t('solar.text-freespin4') }}</span>
      </div>
      <div class="d-flex p-2 mt-1">
        <span class=" m-0 text-sub" :class="`-${lang}`">{{ $t('solar.text-freespin5') }}</span>
      </div>
      <div class="d-flex flex-column nav-name mt-4">
        <section class="d-flex p-2">
          <h5 class="font-weight-bold m-0 text-title" :class="`-${lang} -solar`">{{ $t('solar.paytable.line') }}</h5>
        </section>
      </div>
      <div class="d-flex p-2 mt-3">
        <span class="m-0 text-bet-line" :class="`-${lang}`">{{ $t('solar.text-line1') }}</span>
      </div>
      <div class="d-flex p-2 mb-1">
        <span class="m-0 text-sub" :class="`-${lang}`">{{ $t('solar.text-line2') }}</span>
      </div>
      <div class="d-flex p-2 mb-1">
        <span class="m-0 text-sub" :class="`-${lang}`">{{ $t('solar.text-line3') }}</span>
      </div>
      <div class="justify-content-center d-flex flex-row">
          <img class="mt-3 icon-paytable" :src="require(`../../assets/paytable/solarSpace/pay_line.png`)"
          alt="">
      </div>
      <div class="d-flex p-2 mb-1 justify-content-center">
        <span class="m-0 text-sub-center" :class="`-${lang}`">{{ $t('solar.text-line4') }}</span>
      </div>
      <div class="d-flex p-2 mb-5">
        <span class="m-0 text-sub" :class="`-${lang}`">{{ $t('solar.text-line5') }}</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'paytable-solar',
  props: {
    data: Object,
    lang: String,
  },
  data() {
    return {
      paytable: this.data.config.payTable
    }
  }
}
</script>

<style>

.icon-paytable {
  width: 100%;
}

.content {
  background: #000013;
  height: 100%;
  width: 100%;
  background-size:cover;
  background-attachment: scroll;
  background-repeat: no-repeat;
}

@media screen and (max-width: 768px) {
  .header > div {
    flex-grow: 0;
    width: 33.33%;
  }
}

</style>